import React from "react";
import SimFrame from "./components/SimFrame";
import MainView from "./components/MainView";

// import data of simulators
import dataSim from "../src/data/data.json";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

export default function App() {
  return (
    <div>
      <Router>
        <Switch>
          <Redirect exact from="/" to="/simulaciones-fisica/" />
          <Route exact path="/simulaciones-fisica/" component={MainView} />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simEnTr.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simEnTr.title}
                url={dataSim.simEnTr.url}
                doc={dataSim.simEnTr.doc}
                act={dataSim.simEnTr.act}
                author={dataSim.simEnTr.author}
                email={dataSim.simEnTr.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simIdGa.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simIdGa.title}
                url={dataSim.simIdGa.url}
                doc={dataSim.simIdGa.doc}
                act={dataSim.simIdGa.act}
                author={dataSim.simIdGa.author}
                email={dataSim.simIdGa.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simLoVo.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simLoVo.title}
                url={dataSim.simLoVo.url}
                doc={dataSim.simLoVo.doc}
                act={dataSim.simLoVo.act}
                author={dataSim.simLoVo.author}
                email={dataSim.simLoVo.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simSiPe.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simSiPe.title}
                url={dataSim.simSiPe.url}
                doc={dataSim.simSiPe.doc}
                act={dataSim.simSiPe.act}
                author={dataSim.simSiPe.author}
                email={dataSim.simSiPe.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simEnCo.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simEnCo.title}
                url={dataSim.simEnCo.url}
                doc={dataSim.simEnCo.doc}
                act={dataSim.simEnCo.act}
                author={dataSim.simEnCo.author}
                email={dataSim.simEnCo.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simCoOs.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simCoOs.title}
                url={dataSim.simCoOs.url}
                doc={dataSim.simCoOs.doc}
                act={dataSim.simCoOs.act}
                author={dataSim.simCoOs.author}
                email={dataSim.simCoOs.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simSuRe.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simSuRe.title}
                url={dataSim.simSuRe.url}
                doc={dataSim.simSuRe.doc}
                act={dataSim.simSuRe.act}
                author={dataSim.simSuRe.author}
                email={dataSim.simSuRe.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simBlBo.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simBlBo.title}
                url={dataSim.simBlBo.url}
                doc={dataSim.simBlBo.doc}
                act={dataSim.simBlBo.act}
                author={dataSim.simBlBo.author}
                email={dataSim.simBlBo.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simDaOs.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simDaOs.title}
                url={dataSim.simDaOs.url}
                doc={dataSim.simDaOs.doc}
                act={dataSim.simDaOs.act}
                author={dataSim.simDaOs.author}
                email={dataSim.simDaOs.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simDoPe.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simDoPe.title}
                url={dataSim.simDoPe.url}
                doc={dataSim.simDoPe.doc}
                act={dataSim.simDoPe.act}
                author={dataSim.simDoPe.author}
                email={dataSim.simDoPe.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simMeAx.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simMeAx.title}
                url={dataSim.simMeAx.url}
                doc={dataSim.simMeAx.doc}
                act={dataSim.simMeAx.act}
                author={dataSim.simMeAx.author}
                email={dataSim.simMeAx.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simMaSp.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simMaSp.title}
                url={dataSim.simMaSp.url}
                doc={dataSim.simMaSp.doc}
                act={dataSim.simMaSp.act}
                author={dataSim.simMaSp.author}
                email={dataSim.simMaSp.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simIsMo.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simIsMo.title}
                url={dataSim.simIsMo.url}
                doc={dataSim.simIsMo.doc}
                act={dataSim.simIsMo.act}
                author={dataSim.simIsMo.author}
                email={dataSim.simIsMo.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simFiCh.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simFiCh.title}
                url={dataSim.simFiCh.url}
                doc={dataSim.simFiCh.doc}
                act={dataSim.simFiCh.act}
                author={dataSim.simFiCh.author}
                email={dataSim.simFiCh.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simBoDr.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simBoDr.title}
                url={dataSim.simBoDr.url}
                doc={dataSim.simBoDr.doc}
                act={dataSim.simBoDr.act}
                author={dataSim.simBoDr.author}
                email={dataSim.simBoDr.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simDoOs20231.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simDoOs20231.title}
                url={dataSim.simDoOs20231.url}
                doc={dataSim.simDoOs20231.doc}
                act={dataSim.simDoOs20231.act}
                author={dataSim.simDoOs20231.author}
                email={dataSim.simDoOs20231.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simFlMo20231.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simFlMo20231.title}
                url={dataSim.simFlMo20231.url}
                doc={dataSim.simFlMo20231.doc}
                act={dataSim.simFlMo20231.act}
                author={dataSim.simFlMo20231.author}
                email={dataSim.simFlMo20231.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simPaLa20231.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simPaLa20231.title}
                url={dataSim.simPaLa20231.url}
                doc={dataSim.simPaLa20231.doc}
                act={dataSim.simPaLa20231.act}
                author={dataSim.simPaLa20231.author}
                email={dataSim.simPaLa20231.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simRiPe20231.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simRiPe20231.title}
                url={dataSim.simRiPe20231.url}
                doc={dataSim.simRiPe20231.doc}
                act={dataSim.simRiPe20231.act}
                author={dataSim.simRiPe20231.author}
                email={dataSim.simRiPe20231.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simIsMa20231.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simIsMa20231.title}
                url={dataSim.simIsMa20231.url}
                doc={dataSim.simIsMa20231.doc}
                act={dataSim.simIsMa20231.act}
                author={dataSim.simIsMa20231.author}
                email={dataSim.simIsMa20231.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simHyAt20231.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simHyAt20231.title}
                url={dataSim.simHyAt20231.url}
                doc={dataSim.simHyAt20231.doc}
                act={dataSim.simHyAt20231.act}
                author={dataSim.simHyAt20231.author}
                email={dataSim.simHyAt20231.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simQuAr20232.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simQuAr20232.title}
                url={dataSim.simQuAr20232.url}
                doc={dataSim.simQuAr20232.doc}
                act={dataSim.simQuAr20232.act}
                author={dataSim.simQuAr20232.author}
                email={dataSim.simQuAr20232.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simPiOs20232.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simPiOs20232.title}
                url={dataSim.simPiOs20232.url}
                doc={dataSim.simPiOs20232.doc}
                act={dataSim.simPiOs20232.act}
                author={dataSim.simPiOs20232.author}
                email={dataSim.simPiOs20232.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simGaDi20232.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simGaDi20232.title}
                url={dataSim.simGaDi20232.url}
                doc={dataSim.simGaDi20232.doc}
                act={dataSim.simGaDi20232.act}
                author={dataSim.simGaDi20232.author}
                email={dataSim.simGaDi20232.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simRaDe20232.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simRaDe20232.title}
                url={dataSim.simRaDe20232.url}
                doc={dataSim.simRaDe20232.doc}
                act={dataSim.simRaDe20232.act}
                author={dataSim.simRaDe20232.author}
                email={dataSim.simRaDe20232.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simChPa20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simChPa20241.title}
                url={dataSim.simChPa20241.url}
                doc={dataSim.simChPa20241.doc}
                act={dataSim.simChPa20241.act}
                author={dataSim.simChPa20241.author}
                email={dataSim.simChPa20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simDoSl20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simDoSl20241.title}
                url={dataSim.simDoSl20241.url}
                doc={dataSim.simDoSl20241.doc}
                act={dataSim.simDoSl20241.act}
                author={dataSim.simDoSl20241.author}
                email={dataSim.simDoSl20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simNuRe20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simNuRe20241.title}
                url={dataSim.simNuRe20241.url}
                doc={dataSim.simNuRe20241.doc}
                act={dataSim.simNuRe20241.act}
                author={dataSim.simNuRe20241.author}
                email={dataSim.simNuRe20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simPeMa20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simPeMa20241.title}
                url={dataSim.simPeMa20241.url}
                doc={dataSim.simPeMa20241.doc}
                act={dataSim.simPeMa20241.act}
                author={dataSim.simPeMa20241.author}
                email={dataSim.simPeMa20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simTuEf20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simTuEf20241.title}
                url={dataSim.simTuEf20241.url}
                doc={dataSim.simTuEf20241.doc}
                act={dataSim.simTuEf20241.act}
                author={dataSim.simTuEf20241.author}
                email={dataSim.simTuEf20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simMaIn20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simMaIn20241.title}
                url={dataSim.simMaIn20241.url}
                doc={dataSim.simMaIn20241.doc}
                act={dataSim.simMaIn20241.act}
                author={dataSim.simMaIn20241.author}
                email={dataSim.simMaIn20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simTiDi20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simTiDi20241.title}
                url={dataSim.simTiDi20241.url}
                doc={dataSim.simTiDi20241.doc}
                act={dataSim.simTiDi20241.act}
                author={dataSim.simTiDi20241.author}
                email={dataSim.simTiDi20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simAtSp20241.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simAtSp20241.title}
                url={dataSim.simAtSp20241.url}
                doc={dataSim.simAtSp20241.doc}
                act={dataSim.simAtSp20241.act}
                author={dataSim.simAtSp20241.author}
                email={dataSim.simAtSp20241.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simCiCa20242.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simCiCa20242.title}
                url={dataSim.simCiCa20242.url}
                doc={dataSim.simCiCa20242.doc}
                act={dataSim.simCiCa20242.act}
                author={dataSim.simCiCa20242.author}
                email={dataSim.simCiCa20242.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simCoOs20242.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simCoOs20242.title}
                url={dataSim.simCoOs20242.url}
                doc={dataSim.simCoOs20242.doc}
                act={dataSim.simCoOs20242.act}
                author={dataSim.simCoOs20242.author}
                email={dataSim.simCoOs20242.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simCyMo20242.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simCyMo20242.title}
                url={dataSim.simCyMo20242.url}
                doc={dataSim.simCyMo20242.doc}
                act={dataSim.simCyMo20242.act}
                author={dataSim.simCyMo20242.author}
                email={dataSim.simCyMo20242.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simInMz20242.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simInMz20242.title}
                url={dataSim.simInMz20242.url}
                doc={dataSim.simInMz20242.doc}
                act={dataSim.simInMz20242.act}
                author={dataSim.simInMz20242.author}
                email={dataSim.simInMz20242.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simJaCu20242.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simJaCu20242.title}
                url={dataSim.simJaCu20242.url}
                doc={dataSim.simJaCu20242.doc}
                act={dataSim.simJaCu20242.act}
                author={dataSim.simJaCu20242.author}
                email={dataSim.simJaCu20242.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simThBo20242.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simThBo20242.title}
                url={dataSim.simThBo20242.url}
                doc={dataSim.simThBo20242.doc}
                act={dataSim.simThBo20242.act}
                author={dataSim.simThBo20242.author}
                email={dataSim.simThBo20242.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simPoRa20251.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simPoRa20251.title}
                url={dataSim.simPoRa20251.url}
                doc={dataSim.simPoRa20251.doc}
                act={dataSim.simPoRa20251.act}
                author={dataSim.simPoRa20251.author}
                email={dataSim.simPoRa20251.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simStGe20252.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simStGe20252.title}
                url={dataSim.simStGe20252.url}
                doc={dataSim.simStGe20252.doc}
                act={dataSim.simStGe20252.act}
                author={dataSim.simStGe20252.author}
                email={dataSim.simStGe20252.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simStG220252.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simStG220252.title}
                url={dataSim.simStG220252.url}
                doc={dataSim.simStG220252.doc}
                act={dataSim.simStG220252.act}
                author={dataSim.simStG220252.author}
                email={dataSim.simStG220252.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simNuRe20251.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simNuRe20251.title}
                url={dataSim.simNuRe20251.url}
                doc={dataSim.simNuRe20251.doc}
                act={dataSim.simNuRe20251.act}
                author={dataSim.simNuRe20251.author}
                email={dataSim.simNuRe20251.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simCoSy20252.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simCoSy20252.title}
                url={dataSim.simCoSy20252.url}
                doc={dataSim.simCoSy20252.doc}
                act={dataSim.simCoSy20252.act}
                author={dataSim.simCoSy20252.author}
                email={dataSim.simCoSy20252.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simNoOs20252.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simNoOs20252.title}
                url={dataSim.simNoOs20252.url}
                doc={dataSim.simNoOs20252.doc}
                act={dataSim.simNoOs20252.act}
                author={dataSim.simNoOs20252.author}
                email={dataSim.simNoOs20252.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simSiEa20251.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simSiEa20251.title}
                url={dataSim.simSiEa20251.url}
                doc={dataSim.simSiEa20251.doc}
                act={dataSim.simSiEa20251.act}
                author={dataSim.simSiEa20251.author}
                email={dataSim.simSiEa20251.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simThCo20252.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simThCo20252.title}
                url={dataSim.simThCo20252.url}
                doc={dataSim.simThCo20252.doc}
                act={dataSim.simThCo20252.act}
                author={dataSim.simThCo20252.author}
                email={dataSim.simThCo20252.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simOpGe20251.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simOpGe20251.title}
                url={dataSim.simOpGe20251.url}
                doc={dataSim.simOpGe20251.doc}
                act={dataSim.simOpGe20251.act}
                author={dataSim.simOpGe20251.author}
                email={dataSim.simOpGe20251.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simSoFo20251.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simSoFo20251.title}
                url={dataSim.simSoFo20251.url}
                doc={dataSim.simSoFo20251.doc}
                act={dataSim.simSoFo20251.act}
                author={dataSim.simSoFo20251.author}
                email={dataSim.simSoFo20251.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simPeSo20251.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simPeSo20251.title}
                url={dataSim.simPeSo20251.url}
                doc={dataSim.simPeSo20251.doc}
                act={dataSim.simPeSo20251.act}
                author={dataSim.simPeSo20251.author}
                email={dataSim.simPeSo20251.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simCoMa20252.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simCoMa20252.title}
                url={dataSim.simCoMa20252.url}
                doc={dataSim.simCoMa20252.doc}
                act={dataSim.simCoMa20252.act}
                author={dataSim.simCoMa20252.author}
                email={dataSim.simCoMa20252.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.simMaWh20252.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.simMaWh20252.title}
                url={dataSim.simMaWh20252.url}
                doc={dataSim.simMaWh20252.doc}
                act={dataSim.simMaWh20252.act}
                author={dataSim.simMaWh20252.author}
                email={dataSim.simMaWh20252.email}
              />
            )}
          />

          <Route
            forceRefresh={true}
            exact
            path={dataSim.sim01.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.sim01.title}
                url={dataSim.sim01.url}
                doc={dataSim.sim01.doc}
                act={dataSim.sim01.act}
                author={dataSim.sim01.author}
                email={dataSim.sim01.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.sim02.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.sim02.title}
                url={dataSim.sim02.url}
                doc={dataSim.sim02.doc}
                act={dataSim.sim02.act}
                author={dataSim.sim02.author}
                email={dataSim.sim02.email}
              />
            )}
          />
          <Route
            forceRefresh={true}
            exact
            path={dataSim.sim03.path}
            component={() => (
              <SimFrame
                paneTitle={dataSim.sim03.title}
                url={dataSim.sim03.url}
                doc={dataSim.sim03.doc}
                act={dataSim.sim03.act}
                author={dataSim.sim03.author}
                email={dataSim.sim03.email}
              />
            )}
          />
        </Switch>
      </Router>
    </div>
  );
}
